
export default function AboutHero() {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.1), rgba(30, 64, 175, 0.1)), url('https://public.readdy.ai/ai/img_res/7391faf914ea87e9387d18b1d57fc490.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          About Our English Learning Method
        </h1>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
          We believe learning English should be easy, practical, and fun. Our proven method has helped thousands 
          of students speak confidently in just weeks, not years.
        </p>
      </div>
    </section>
  );
}
